module.exports = __webpack_public_path__ + "static/media/320905__suzenako__the-ding.36909792.wav";